












































































import { Component, Vue } from 'vue-property-decorator';
import CollapseTransition from '@/components/collapseTransition/collapseTransition';
import PagingUnit from '@/components/paging/paging.vue';
import { institutionServer, oneClickAlarmServer } from '@/api/installServer';
import { TableStripe } from '@/mixins/tableStripe';
import DetailPage from './detailPage.vue';
import { arrayToTree } from '@/util/arrayToTree';

@Component({
  components: { CollapseTransition, PagingUnit, DetailPage },
  mixins: [TableStripe],
})
export default class AlarmList extends Vue {
  showFlag = 1;
  rowId: any = '';

  queryDataForm: object = {
    pageNo: 1,
    pageSize: 10,
  };
  total = 0; // 数据总共多少条

  // table数据
  tableData: any[] = [];
  searchForm: any = {
    companyId: '',
    contact: '',
    isHandle: null,
  };
  dateArr: any = [];
  subSpaceByAuthOptions: any[] = [];

  /**
   * @desc  分页发生改变触发，获取到新的 table 数据。
   */
  getListData() {
    this.getAllData();
  }

  /**
   *【表格】表格详情按钮
   * @Params
   * @return
   **/
  handleTableDetailBtnClick(data: any) {
    this.showFlag = 2;
    this.rowId = data.id;
  }

  getSubSpaceByAuth() {
    // 发起接口请求，获取分页数据
    institutionServer
      .getDeptAndSubDeptList({})
      .then((res: any) => {
        this.subSpaceByAuthOptions = arrayToTree(res.data);
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }
  /**
   * @desc Vue 创建数据生命周期
   * @param1 暂无
   * @returns 暂无
   */
  created() {
    // 获取所有数据
    this.getSubSpaceByAuth();
    this.getAllData();
  }
  /**
   * @desc 获取所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getAllData() {
    // 获取所有数据
    oneClickAlarmServer
      .getOneClickAlarmList({
        pageNo: (this.queryDataForm as any).pageNo,
        pageSize: (this.queryDataForm as any).pageSize,
        companyId: this.searchForm.companyId,
        contact: this.searchForm.contact || null,
        alarmStartTime: this.dateArr && this.dateArr.length ? this.dateArr[0] : null,
        alarmEndTime: this.dateArr && this.dateArr.length ? this.dateArr[1] : null,
        isHandle: this.searchForm.isHandle,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      })
      .catch((error: any) => {
        this.$message.error('获取失败,请稍后重试!');
      });
  }
  private onSearch() {
    this.getAllData();
  }

  private onreset() {
    this.searchForm = {
      companyId: '',
      contact: '',
      alarmStartTime: null,
      alarmEndTime: null,
      isHandle: null,
    };
    this.dateArr = [];
    this.queryDataForm = {
      pageNo: 1,
      pageSize: 10,
    };
    this.getAllData();
  }
  closePage() {
    this.showFlag = 1;
    this.getAllData();
  }
}
